import React, { useEffect, useState } from "react";

import "./Information-Card-Pc.scss";

//imports for user data
import { useSelector } from "react-redux";

const InformationCardPc = ({
  Title,
  // cardData,
  setTableToView,
  valueToSet,
}) => {
  const { profile } = useSelector((state) => state.landlordslice);

  const [cardData, setCardData] = useState({});

  useEffect(() => {
    //switchcase to set card data according to the title
    let latestInvoice;
    switch (Title) {
      case "Invoices Pending":
        latestInvoice = profile?.tenant_details?.unpaidInvoices;
        console.log("Tm", latestInvoice);
        const cardData1 = {
          Title: "Invoices Pending",
          fields: ["rent", "water", "arrears", "garbage"],
          rent: latestInvoice?.rent || "0",
          water: latestInvoice?.water || "0",
          arrears: latestInvoice?.arrears || "0",
          serviceCharge: latestInvoice?.serviceFee || "0",
          unpaidDeposit: latestInvoice?.unpaidDeposit || "0",
          garbage: latestInvoice?.garbage || "0",
          lateFee: latestInvoice?.lateFee || "0",
          totalAmount:
            (latestInvoice?.rent || 0) +
            (latestInvoice?.water || 0) +
            (latestInvoice?.arrears || 0) +
            (latestInvoice?.serviceFee || 0) +
            (latestInvoice?.unpaidDeposit || 0) +
            (latestInvoice?.garbage || 0) +
            (latestInvoice?.lateFee || 0),

        };
        setCardData(cardData1);
        break;

      case "Invoices Paid":
        latestInvoice = profile?.tenant_details?.payments?.[0];
        let totalRent = 0;
        let totalWater = 0;
        let totalArrears = 0;
        let totalServiceCharge = 0;
        let totalUnpaidDeposit = 0;
        let totalGarbage = 0;
        let totalLateFee = 0;
        let totalAmount = 0;

        profile?.tenant_details?.payments?.forEach((payment) => {
          totalRent += payment?.rent || 0;
          totalWater += payment?.water_bill || 0;
          totalArrears += payment?.arrears || 0;
          totalServiceCharge += payment?.serviceCharge || 0;
          totalUnpaidDeposit += payment?.deposit || 0;
          totalGarbage += payment?.garbage_charge || 0;
          totalLateFee += payment?.lateFee || 0;
          totalAmount += payment?.amount || 0;
        });

        latestInvoice = {
          rent: totalRent,
          water_bill: totalWater,
          arrears: totalArrears,
          serviceCharge: totalServiceCharge,
          deposit: totalUnpaidDeposit,
          garbage_charge: totalGarbage,
          lateFee: totalLateFee,
          amount: totalAmount,
        };
        const cardData2 = {
          Title: "Invoices Paid",
          fields: ["rent", "water", "arrears", "garbage"],
          rent: latestInvoice?.rent || "0",
          water: latestInvoice?.water_bill || "0",
          arrears: latestInvoice?.arrears || "0",
          serviceCharge: latestInvoice?.serviceCharge || "0",
          unpaidDeposit: latestInvoice?.deposit || "0",
          garbage: latestInvoice?.garbage_charge || "0",
          lateFee: latestInvoice?.lateFee || "0",
          totalAmount: latestInvoice?.amount || "0",
          
        };
        setCardData(cardData2);
        break;

      case "Arrears":
        latestInvoice = profile?.tenant_details?.unpaidInvoices;
        const cardData3 = {
          Title: "Arrears",
          fields: ["rent", "water", "arrears", "garbage"],
          rent: latestInvoice?.rent || "0",
          water: latestInvoice?.water || "0",
          arrears: latestInvoice?.arrears || "0",
          serviceCharge: latestInvoice?.serviceFee || "0",
          unpaidDeposit: latestInvoice?.unpaidDeposit,
          garbage: latestInvoice?.garbage,
          totalAmount:
            (latestInvoice?.rent || 0) +
            (latestInvoice?.water || 0) +
            (latestInvoice?.arrears || 0) +
            (latestInvoice?.serviceFee || 0) +
            (latestInvoice?.unpaidDeposit || 0) +
            (latestInvoice?.garbage || 0) +
            (latestInvoice?.lateFee || 0),
        };
        setCardData(cardData3);
        break;

      case "Other charges":
        latestInvoice = profile?.tenant_details?.unpaidInvoices;
        const cardData4 = {
          Title: "Other charges",
          fields: ["arrears", "service", "deposit"],
          rent: latestInvoice?.arrears,
          water: latestInvoice?.serviceFee,
          arrears: latestInvoice?.unpaidDeposit,
          totalAmount:
            (latestInvoice?.arrears || 0) +
            (latestInvoice?.serviceFee || 0) +
            (latestInvoice?.unpaidDeposit || 0),
        };
        console.log("cardData4", cardData4);
        setCardData(cardData4);

        break;
      case "Pending approval":
        latestInvoice = profile?.tenant_details?.pendingPayments?.[0];
        console.log("Tm", latestInvoice);
        const cardData5 = {
          Title: "Invoices Pending",
          fields: ["rent", "water", "arrears", "garbage"],
          rent: latestInvoice?.rent || "0",
          water: latestInvoice?.water || "0",
          arrears: latestInvoice?.arrears || "0",
          serviceCharge: latestInvoice?.service_charge || "0",
          unpaidDeposit: latestInvoice?.deposit || "0",
          garbage: latestInvoice?.garbage || "0",
          totalAmount: latestInvoice?.amount || "0",
        };
        setCardData(cardData5);
        break;

      default:
        break;
    }
  }, [profile]);

  //data received from the parent component
  const dataToDisplay = {
    rentPercentage: (cardData?.rent / cardData?.totalAmount) * 100 || 0,
    waterPercentage: (cardData?.water / cardData?.totalAmount) * 100 || 0,
    arrearsPercentage: (cardData?.arrears / cardData?.totalAmount) * 100 || 0,
    garbagePercentage: (cardData?.garbage / cardData?.totalAmount) * 100 || 0,
  };

  // Calculate the total to check if all values are zero
  const total =
    dataToDisplay.rentPercentage +
    dataToDisplay.waterPercentage +
    dataToDisplay.arrearsPercentage +
    dataToDisplay.garbagePercentage;

  const rentPercentage =
    total !== 0 ? (dataToDisplay.rentPercentage / total) * 100 : 0;
  const waterPercentage =
    total !== 0 ? (dataToDisplay.waterPercentage / total) * 100 : 0;
  const arrearsPercentage =
    total !== 0 ? (dataToDisplay.arrearsPercentage / total) * 100 : 0;
  const garbagePercentage =
    total !== 0 ? (dataToDisplay.garbagePercentage / total) * 100 : 0;

  // Calculate percentage stops
  const rentEnd = rentPercentage;
  const waterEnd = rentEnd + waterPercentage;
  const arrearsEnd = waterEnd + arrearsPercentage;
  const garbageEnd = arrearsEnd + garbagePercentage;

  const cardStyle = {
    backgroundColor: "#1e1e1e",
    padding: "20px",
    borderRadius: "15px",
    width: "100%",
    overflow: "hidden",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    margin: "10px",
    color: "#ffffff",
    display: "flex",
  };

  const headerStyle = {
    margin: 0,
    fontSize: "1.3em",
  };

  const subHeaderStyle = {
    color: "#bbbbbb",
    fontSize: "0.9em",
    marginBottom: "20px",
  };

  const circleContainerStyle = {
    textAlign: "center",
    marginTop: "20px",
    position: "relative",
  };

  const circleStyle = {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    background: `
      conic-gradient(
        #293947 0% ${rentEnd}%, 
        #64A371 ${rentEnd}% ${waterEnd}%, 
        #B99963 ${waterEnd}% ${arrearsEnd}%, 
        #377771 ${arrearsEnd}% ${garbageEnd}%
      )`,
    position: "relative",
    margin: "0px",
  };
  const circleBeforeStyle = {
    content: '""',
    width: "90px", // Adjust this value to change the size of the donut hole
    height: "90px",
    borderRadius: "50%",
    backgroundColor: "white", // Match the background of the card
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const amountStyle = {
    fontSize: "18px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
    position: "relative",
    zIndex: 1,
  };

  const percentageStyle = {
    color: "#293947 ",
    fontSize: "0.85em",
    marginTop: "5px",
    position: "relative",
    zIndex: 1,
  };

  const categoryListStyle = {
    marginTop: "20px",
    marginLeft: "10px",
  };

  const categoryStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
  };

  const dotStyle = {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "0px",
  };

  const labelStyle = {
    flexGrow: 1,
    marginLeft: "10px",
    fontFamily: "Karla, sans-serif",
    fontWeight: "700!important",
    textAlign: "left",
  };

  const valueStyle = {
    fontWeight: "bold",
    marginLeft: "10px",
    color: "#9D9D9D",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
  };

  const buttonStyle = {
    backgroundColor: "transparent",
    border: "1px solid #9D9D9D",
    color: "black",
    fontSize: "12px",
    padding: "3px 5px",
    borderRadius: "5px",
    fontFamily: "Poppins, sans-serif",
    width: "100%",
    cursor: "pointer",
    transition: "background-color 0.3s",
    transition: "color 0.3s",
  };

  const buttonHoverStyle = {
    backgroundColor: "#333",
  };

  return (
    <div className="individual-card">
      <button
        style={{
          margin: 0,
          padding: "10px 20px",
          background: "none",
          border: "none",
          cursor: setTableToView ? "pointer" : "default",
          width: "100%",
        }}
        onClick={() => {
          if (setTableToView && valueToSet) {
            console.log("clicked");
            setTableToView(valueToSet);
          }
        }}
      >
        <div className="top-half">
          <div className="title-and-date">
            <div className="title">{Title}</div>
            <div className="date">Data from 10/9/2018</div>
          </div>
          <div className="right-half"></div>
        </div>
        <div className="bottom-half">
          <div style={circleContainerStyle}>
            <div style={circleStyle}>
              <div style={circleBeforeStyle}>
                <span style={amountStyle}>
                  {cardData?.totalAmount?.toLocaleString()}
                </span>
                {/* <span style={percentageStyle}>↓ 2.1%</span> */}
              </div>
            </div>
          </div>
          {/* list of categories */}
          <div style={categoryListStyle}>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#293947 " }}></span>
              <span style={{ ...labelStyle, color: "#293947 " }}>
                {cardData?.fields?.[0]}
              </span>
              <span style={valueStyle}>
                {dataToDisplay?.rentPercentage.toFixed(0)}%
              </span>
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#64A371" }}></span>
              <span style={{ ...labelStyle, color: "#64A371" }}>
                {cardData?.fields?.[1]}
              </span>
              <span style={valueStyle}>
                {dataToDisplay?.waterPercentage.toFixed(0)}%
              </span>
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#B99963" }}></span>
              <span style={{ ...labelStyle, color: "#B99963" }}>
                {cardData?.fields?.[2]}
              </span>
              <span style={valueStyle}>
                {dataToDisplay?.arrearsPercentage.toFixed(0)}%
              </span>
            </div>
            {cardData?.fields?.[3] && (
              <>
                <div style={categoryStyle}>
                  <span
                    style={{ ...dotStyle, backgroundColor: "#377771" }}
                  ></span>
                  <span style={{ ...labelStyle, color: "#377771" }}>
                    {cardData?.fields?.[3]}
                  </span>
                  <span style={valueStyle}>
                    {dataToDisplay?.garbagePercentage.toFixed(0)}%
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </button>

      {/* <div style={circleContainerStyle}>
                <div style={circleStyle}>
                    <div style={circleBeforeStyle}></div>
                    <span style={amountStyle}>$8,295</span>
                    <span style={percentageStyle}>↓ 2.1%</span>
                </div>
            </div> */}
    </div>
  );
};

export default InformationCardPc;
